import { withInstall } from '../utils'
import Com from './src/ScrollContainer.vue'

export * from './src/typing'

export const ScrollContainer = withInstall(Com)
